import { render, staticRenderFns } from "./ActionByLinkDelegationDecisionView.vue?vue&type=template&id=c393dfca&scoped=true&"
import script from "./ActionByLinkDelegationDecisionView.vue?vue&type=script&lang=js&"
export * from "./ActionByLinkDelegationDecisionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c393dfca",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c393dfca')) {
      api.createRecord('c393dfca', component.options)
    } else {
      api.reload('c393dfca', component.options)
    }
    module.hot.accept("./ActionByLinkDelegationDecisionView.vue?vue&type=template&id=c393dfca&scoped=true&", function () {
      api.rerender('c393dfca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/action-by-link/delegation/ActionByLinkDelegationDecisionView.vue"
export default component.exports